import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-profile",
  templateUrl: "./admin-profile.component.html",
  styleUrls: ["./admin-profile.component.css"],
})
export class AdminProfileComponent implements OnInit {
  profileForm!: FormGroup;
  editGeneralInfo: boolean = false;
  maxDate = new Date();
  public mobileVerified = 0;
  public emailVerified = 0;
  public edit1 = true;
  loading: boolean = false;
  profileImage: any;
  file: any = "";
  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  token: any;
  profileData: any;
  profileUpdate: any;
  profileLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private services: AdminService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");

    this.profileForm = this.formBuilder.group({
      name: ["", Validators.required],
      username: [""],
      employee_id: [""],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: [
        "",
        Validators.compose([
          // Validators.required,
          Validators.pattern(this.emailregex),
        ]),
      ],
      dob: [""],
      gender: [""],
      profile_pic: [""],
    });
    this.getProfile();
  }

  public GoToDashboard() {
    this.router.navigate(["/admin/dashboard"]);
  }

  public SendOtp() {}

  public get ProfileFormControl() {
    return this.profileForm.controls;
  }

  public onEditProfile() {
    this.edit1 = false;
    if ((this.editGeneralInfo = !this.editGeneralInfo)) {
      this.ProfileFormControl["name"].setValue(this.profileData.name);
      this.ProfileFormControl["username"].setValue(this.profileData.username);
      this.ProfileFormControl["employee_id"].setValue(
        this.profileData.employee_id
      );
      this.ProfileFormControl["mobile"].setValue(this.profileData.mobile);
      this.ProfileFormControl["email"].setValue(this.profileData.email);
      this.ProfileFormControl["dob"].setValue(this.profileData.dob);
      this.ProfileFormControl["gender"].setValue(this.profileData.gender);
    }
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.profileLoading = true;
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.profileLoading = false;
          this.profileImage = response.body.image_link;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public updateProfile() {
    this.edit1 = true;
    if (this.profileForm.valid) {
      const profileObj = {
        name: this.profileForm.value.name,
        username: this.profileForm.value.username,
        mobile: this.profileForm.value.mobile,
        email: this.profileForm.value.email,
        dob: this.profileForm.value.dob,
        gender: this.profileForm.value.gender,
        profile_pic: this.profileImage,
        employee_id: this.profileForm.value.employee_id,
      };
      this.loading = true;
      this.profileUpdate = "NA";
      this.services.profileUpdate(profileObj, this.token).subscribe(
        (response: any) => {
          localStorage.setItem("adminProfile", profileObj.profile_pic);
          localStorage.setItem("adminUserName", profileObj.name || profileObj.username);
          this.profileUpdate = "success";
          this.loading = false;
          this.getProfile();
          this.editGeneralInfo = false;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    } else {
      this.profileForm.markAllAsTouched();
    }
  }

  public getProfile() {
    this.services.profileGet(this.token).subscribe(
      (response: any) => {
        this.profileData = response.body.data;
        this.profileImage = response.body.data.profile_pic;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
}
